module.exports = __webpack_public_path__ + "img/profile-prjweb.aedc7248.png";